import { render, staticRenderFns } from "./ExamAanmeldingenAddEdit.vue?vue&type=template&id=f6f52e08&scoped=true"
import script from "./ExamAanmeldingenAddEdit.vue?vue&type=script&lang=js"
export * from "./ExamAanmeldingenAddEdit.vue?vue&type=script&lang=js"
import style0 from "./ExamAanmeldingenAddEdit.vue?vue&type=style&index=0&id=f6f52e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f52e08",
  null
  
)

export default component.exports